<template>
  <div>
    <v-snackbar
      v-model="snackbar"
      color="primary"
      :multi-line="true"
      :timeout="-1"
      location="top"
    >
      <b style="font-size: larger"> {{ $t("basics.error") }} </b><br /><br />
      <span v-if="$debug">
        <span v-if="errorMessage">{{ errorMessage }}</span>
        <span v-else>{{ $t("messages.axiosErrorMsg") }}</span>
        <br />
        <span
          v-if="additionalMessage"
          style="max-width: 100%; max-height: 200px; overflow-y: auto; overflow-x: hidden"
          ><b>{{ additionalMessage }}</b></span
        >
      </span>
      <span v-else-if="status">
        {{ $t("errorCodes." + status) }}

       <p v-if="status==403"> {{ $route.path }}</p>
      </span>
      <template v-slot:actions>
        <v-btn class="py-3 mb-3" text @click="snackbar = false"> Ok! </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script>
export default {
  name: "errorDisplay",

  props: ["showErrorDisplay", "errorMessage", "additionalMessage", "status"],

  data() {
    return {
      snackbar: false,
    };
  },

  watch: {
    showErrorDisplay() {
      this.snackbar = true;
    },
  },
};
</script>
